// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__uu7oe","rootSmall":"AddTileButton_rootSmall__1LGKA"};